import { SContactLink } from "./index.styled"
import { IContactLink } from "./types"

const ContactLink:React.FC<IContactLink> = ({ title, imgSrc, value, link }) => {
    return (
        <SContactLink>
            <h4 className="contact-header">{title}</h4>
            <a href={link} className="contact-detail">
                <div className="icon-container"><img src={imgSrc} alt="call" /></div>
                <div className="contact-address">{value}</div>
            </a>
        </SContactLink>
    )
}

export default ContactLink